import { getFontStyles } from '@ycos/primitives'
import mrpStyles from './../mrpRtl.json'

export default {
  ...getFontStyles(mrpStyles, { type: 'Heading', name: 'A2' }),
  color: mrpStyles.colors.PrimaryBlack,
  lineColor: mrpStyles.colors.SecondaryGreySteel,
  textTransform: 'none',
  loyaltyFontStyle: {
    fontWeight: '400',
    fontSize: '22px',
    lineHeight: '33px'
  }
}
